import AccountConfirmNotify from './account-confirm-notify';
export default AccountConfirmNotify;
